/* global axios */
import ApiClient from './ApiClient';

class ArticleReportsAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  getBulkReports(portalSlugs = [], filters = {}) {
    return axios.get(`${this.baseURL()}/article_reports/bulk_report`, {
      params: {
        portal_slugs: portalSlugs,
        ...filters,
      },
    });
  }

  getReports(portalSlug, filters = {}) {
    return axios.get(`${this.baseURL()}/portals/${portalSlug}/article_reports`, {
      params: filters,
    });
  }

  exportReports(portalSlugs, filters = {}, format = 'csv') {
    // If multiple portals, use bulk export endpoint
    if (Array.isArray(portalSlugs) && portalSlugs.length > 1) {
      return axios.post(`${this.baseURL()}/article_reports/bulk_export.csv`, {
        portal_slugs: portalSlugs,
        ...filters,
      }, {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'text/csv'
        }
      });
    }
    
    // Single portal export
    const portalSlug = Array.isArray(portalSlugs) ? portalSlugs[0] : portalSlugs;
    return axios.get(`${this.baseURL()}/portals/${portalSlug}/article_reports/export.csv`, {
      params: filters,
      responseType: 'blob',
      headers: {
        'Accept': 'text/csv'
      }
    });
  }

  baseURL() {
    const accountId = this.getAccountId();
    return `/api/v1/accounts/${accountId}`;
  }

  getAccountId() {
    if (window.chatwootConfig?.accountId) {
      return window.chatwootConfig.accountId;
    }
    
    const path = window.location.pathname;
    const match = path.match(/\/accounts\/(\d+)/);
    return match ? match[1] : null;
  }
}

export default new ArticleReportsAPI();
